import { useCallback } from "react"

type MediaElement = HTMLImageElement | HTMLVideoElement | HTMLAudioElement

/**
 * Ref callback that points a media element's `src` at a blob URL for
 * `file`, and revokes that URL when the element detaches or `file`
 * changes. Creating and revoking inside the ref lifecycle keeps the pair
 * balanced (including StrictMode's detach/re-attach) without mirroring
 * the URL into state from an effect.
 */
export function useObjectUrlSrc(file: File) {
  return useCallback(
    (el: MediaElement | null) => {
      if (!el) return
      const url = URL.createObjectURL(file)
      el.src = url
      return () => URL.revokeObjectURL(url)
    },
    [file],
  )
}
